import { Button, Grid, MenuItem, TextField, Checkbox, FormControlLabel, InputLabel } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import { getEvents } from "../../../store/constructs/events/selectors";
import { basic, validationMessages, requiredOnly, patternOnly, patternOnlyMessage, duplicateEventName } from '../../../config/validations';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { makeStyles } from '@material-ui/core/styles';
import { getAllTransactions } from '../../../store/constructs/transactions/selectors';
import { getTemplatecluserletMessages } from '../../../store/constructs/templated_clusterlet/selectors'
import UpdateEventAlert from '../../molecules/alerts/UpdateEventAlert'
import { checkValidConnection } from "../../../store/constructs/clusterlet_connections/selectors";
import { handleSnackBar } from '../../../store/global/actions';
import { getDetailsFromUrl } from '../../../services/blueprint';
import { invokePostService, invokeGetService, setReRender, setFocusElement, toggleRightDrawer } from "../../../store/global/actions";
import { getMessageForDropDown } from '../../../services/entities/common'
import { getBottomDrawerStatus, getElementOnFocus, getReRender } from '../../../store/global/selectors';
import { useParams } from 'react-router-dom';
import { convertObjectToArrays, filterSchemaMessages, filterUniqueMessages, findMessageAndFields, findTransactionAssociatedConstructs, findTriggerEvent, generateMongoId, validateNonAsciiChars } from "../../../utils/commonUtils";
import DatabaseSchemaValidationAlert from "../alerts/DatabaseSchemaValidationAlert";
import SkeletonLoader from "../../atoms/loader/SkeletonLoader";
import { constructIds } from "../../../config/common";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";


export default function EditEvent({ element, onCancel, onCompletion, handleUpdateInDiagram }) {
    const dispatch = useDispatch();
    const params = useParams();
    const filter = createFilterOptions();
    const events = useSelector(getEvents);
    const bottomDrawerStatus = useSelector(getBottomDrawerStatus);

    const currentUrl = window.location.href;
    const [slug, blueprintID, entity, transactionID] = currentUrl.split('/').slice(4);


    const [messageList, setMessageList] = useState([]);
    const [storeMessages, setStoreMessages] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [alertDialog, setAlertDialog] = useState(false);
    const [srcError, setSrcError] = useState(null);
    const [dstError, setDstError] = useState(null);
    const [clusterlets, setClusterlets] = useState([]);
    const [selectedEvent, setSelectdEvent] = useState(element?.item || null);
    const [transactionNodes, setTransactionNodes] = useState([]);
    const [action, setAction] = useState({});
    const [showTargetInstance, setShowTargetInstance] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [clusterletConnections, setClusterletConnections] = useState(null);
    const [allTransactions, setAllTransactions] = useState([])
    const [allEvents, setAllEvents] = useState([])
    const [selectedMessage, setSelectedMessage] = useState(null);

    const allTransactionsList = useSelector(getAllTransactions);
    const templateMessages = useSelector(getTemplatecluserletMessages) || [];
    const reRender = useSelector(getReRender);

    const allMessages = [...messageList, ...templateMessages]
    const selectedTransaction = allTransactionsList.find(item => item.events.map(event => event.id).includes(element.id))
    const [loading, setLoading] = useState(true)
    const [msg, setMsg] = useState({ _id: "" });
    const [isResponseEvent, setResponseEvent] = useState(false)
    const [allClusterlets, setAllClusterlets] = useState([])
    const { entityId } = getDetailsFromUrl();
    const [messagesFromSchema, setMessagesFromSchema] = useState([])
    const [fieldsLists, setAllFieldList] = useState([]);
    const [src, setSrc] = useState(element?.item?.src || null);
    const [dst, setDst] = useState(element?.item?.dst || null);
    const protocol = element.protocol ? element.protocol : null;

    const getClusterlet = (id) => {
        const clusterlet = clusterlets?.find(clusterlet => clusterlet?._id === id)
        return clusterlet;
    }

    const { register, handleSubmit, formState: { errors }, setValue, control, clearErrors, watch, getValues, setError } = useForm({
        defaultValues: {
            name: element?.name || selectedEvent?.name,
            desc: element?.desc || selectedEvent?.desc,
            condition: selectedEvent?.condition || "",
            instance: selectedEvent?.instance || "",
            src: selectedEvent?.src,
            dst: selectedEvent?.dst,
            validate: selectedEvent?.validation || "",
            message: selectedEvent?.message,
            onsend: selectedEvent?.attributes?.onsend,
            onrecv: selectedEvent?.attributes?.onrecv,
            selectedMessage: selectedEvent?.message,
        }
    });

    const source = watch('src') ? watch('src') : src;
    const destination = watch('dst') ? watch('dst') : dst;
    useEffect(() => {
        setShowTargetInstance(clusterlets.find(item => item._id === source)?.type !== 1 && clusterlets.find(item => item._id === destination)?.type !== 1 ? true : false)
    }, [source, destination, showTargetInstance])

    useEffect(() => {
        setDataLoading(true)
        getInitialData().then(([associatedData, constructs, schemaResponse]) => {
            let schemaMessages = [];
            if (schemaResponse?.status) {
                if (schemaResponse?.data !== undefined && schemaResponse?.data?.schema !== undefined) {
                    let formattedSchema = convertObjectToArrays(schemaResponse?.data?.schema)
                    schemaMessages = formattedSchema.messages || [];
                    setMessagesFromSchema(formattedSchema.messages)
                    setAllFieldList(formattedSchema.fields || [])
                }
            }

            if (associatedData.status) {
                const event = associatedData?.data?.event;
                const clusterlets = associatedData?.data?.clusterlets;
                setSelectdEvent(event || null);
                setSrc(event?.src);
                setDst(event?.dst);
                setValue("dst", event?.dst);
                setValue("name", event?.name);
                setShowTargetInstance(clusterlets?.find(item => item._id === event?.src)?.type !== 1 && clusterlets?.find(item => item._id === event?.dst)?.type !== 1 ? true : false)

                setClusterlets(clusterlets || []);
                const messagesArray = associatedData?.data?.messages || [];
                const messageDataOfSelectedEvent = messagesArray.find(msg => msg._id.toString() === event.message);
                if (messageDataOfSelectedEvent){
                    setSelectedMessage({ label: messageDataOfSelectedEvent.name, value: selectedEvent.message });
                } 

                const uniqueSchemaMessages = filterUniqueMessages({existingMsgs: messagesArray,schemaMessages: schemaMessages || []}) || [];
                const existingMessagesWithDesc = attachDescWitExistingSchemaMsgs({schemaMessages, existingMsgs: messagesArray});
                const allMessageList = [
                    ...(getMessageForDropDown(existingMessagesWithDesc || []) || []),
                    ...uniqueSchemaMessages
                ];
                const sortedMessageList = allMessageList.sort((a, b) => {
                    if (a.type === b.type) return 0;
                    return a.type === "user" ? -1 : 1;
                  });
                setMessageList(sortedMessageList);
                setStoreMessages(associatedData?.data?.messages || [])
                setClusterletConnections(associatedData?.data.connections || [])
                setTransactionNodes((associatedData?.data?.clusterlets || [])
                    .map(item => {
                        if ((associatedData?.data?.parentTransaction?.clusterlets || [])
                            .map(item => item.id).includes(item._id)) return { id: item._id, name: item.name }
                    })
                    .filter(item => item)
                    .sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()) })
                )
                setDataLoading(false);

            } else if (associatedData?.status === false && associatedData?.code === 255) {
                if (!bottomDrawerStatus) dispatch(toggleRightDrawer());
                dispatch(setReRender());
            }

            if (constructs?.status) {
                setAllTransactions(constructs.data.transactions)
                setAllEvents(constructs.data?.events);
                setAllClusterlets(constructs.data?.clusterlets)

                setShowTargetInstance(constructs.data?.clusterlets.find(item => item._id === source)?.type !== 1 && constructs.data?.clusterlets.find(item => item._id === destination)?.type !== 1 ? true : false)
            } else {
                console.error("Fetching all constructs failed", constructs);
            }

            setLoading(false);

        })

    }, [element, reRender])

    const getInitialData = async () => {
        if (element === undefined || element?.id === undefined) {
            setDataLoading(true)
            return;
        }

        setDataLoading(true);
        const promises = [
            dispatch(invokeGetService('getEventAssociatedData', [element.id, entityId])),
            dispatch(invokeGetService('getBlueprintConstructs', {}))
        ]

        if (protocol !== null) {
            promises.push(dispatch(invokeGetService('getDbSchema', [protocol])));
        }

        return await Promise.all(promises)

    }

    const attachDescWitExistingSchemaMsgs = ({schemaMessages, existingMsgs}) => {
        const schemaDescMap = new Map(
            (schemaMessages || [])
              .filter(item => item.desc)
              .map(item => [item.label, item.desc])
          );
        
          existingMsgs = existingMsgs.map(msg => ({
            ...msg,
            desc: schemaDescMap.get(msg.name) ?? msg.desc
          }));
          return existingMsgs;
    }


    useEffect(() => {
        if (msg !== undefined) setValue("selectedMessage", msg._id);
    }, [msg])

    const messages = { ...validationMessages, ...patternOnlyMessage, validate: 'The event name is already used.' };


    const formatEvent = (event) => {
        let newEvent = {
            name: event.name,
            desc: event.desc,
            message: typeof event.selectedMessage === "object" ? event.selectedMessage.value : event.selectedMessage,
            attributes: {
                onsend: selectedEvent?.attributes?.onsend,
                onrecv: selectedEvent?.attributes?.onrecv
            },
            isError: event?.error_resp_event ? true : false,
            src: event.src,
            dst: event.dst,
            type: 8,
            condition: selectedEvent?.condition ? selectedEvent?.condition : "",
            validate: selectedEvent?.validation || "none",
            timeout: selectedEvent?.timeout || "",
            key: selectedEvent?.key || "",
            context: selectedEvent?.context || ""
        }


        if (event.instance !== '' && event.instance !== undefined) {
            newEvent.instance = event.instance
        }

        return newEvent;
    }


    const onUpdate = (data) => {
        if (srcError?.length > 0 || dstError?.length > 0) return;

        const srcClusterlet = clusterlets.find(item => item._id === data.src);
        const dstClusterelt = clusterlets.find(item => item._id === data.dst);

        if (checkValidConnection({ src: srcClusterlet._id, dst: dstClusterelt._id, smConnections: clusterletConnections, clusterlets }) === false) {
            dispatch(handleSnackBar({ open: true, message: `Connection not found between clusterlets ${srcClusterlet.name} and ${dstClusterelt.name} in system model`, severity: "warning" }));
            return;
        }
        onEventUpdate(data);
    }

    const onEventUpdate = (eventData) => {
        setIsCreating(true)
        let gotoEventType = false;
        eventData.selectedMessage = selectedMessage?.value;

        let newEvent = formatEvent(eventData);
        const srcNode = getClusterlet(newEvent.src);
        const dstNode = getClusterlet(newEvent.dst);
        const protocol = srcNode?.type === 1 ? srcNode?.attributes?.type : dstNode?.type === 1 ? dstNode?.attributes?.type : undefined;
        let messageExists = storeMessages.find(msg => msg._id.toString() === eventData.selectedMessage);
        let selectedMessagAndFields = findMessageAndFields(messagesFromSchema, fieldsLists, eventData.selectedMessage)

        if (msg !== null && msg._id === eventData.selectedMessage) gotoEventType = true;

        if (handleUpdateInDiagram) handleUpdateInDiagram({ id: element?.id, type: "event", data: newEvent });

        const payload = {
            event: newEvent,
            selectedEvent: selectedEvent,
            selectedTransactionId: params?.transaction,
            messageData: (messageExists === undefined && selectedMessagAndFields !== undefined && selectedMessagAndFields?.message != null) ? selectedMessagAndFields : null
        }

        dispatch(invokePostService('updateEvent', payload, [element.id]))
            .then(savedData => {
                if (savedData.status) {
                    onCompletion(savedData?.data, 'edit', gotoEventType, protocol);
                } else {
                    if (savedData?.code === "600") {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, { message: error.message });
                        });
                    } else if (savedData?.message) {
                        dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));
                    }
                }
                setIsCreating(false);


            })


    }


    const listenChange = (e) => {

        const { src, dst } = getValues()

        setShowTargetInstance(
            clusterlets.find(item => item._id === src).type !== 1 &&
                clusterlets.find(item => item._id === dst).type !== 1 ? true : false
        )

        if (e.target.name === 'src' && e.target.value === destination) {
            setSrcError('Source and Destination cannot be the same')
        } else if (e.target.name === 'dst' && e.target.value === source) {
            setDstError('Source and Destination cannot be the same ')
        } else {
            setSrcError(''); setDstError('')
        }
    }


    useEffect(() => {
        const { clusterlets: selectedClusterlets, events: selectedEvents, transaction: selectedTransaction } = findTransactionAssociatedConstructs({ transactionId: params?.transaction, transactions: allTransactions, events: allEvents, clusterlets: allClusterlets })

        const triggeringEvent = findTriggerEvent({ clusterlets: selectedClusterlets, events: selectedEvents, transaction: selectedTransaction })

        if (dst === triggeringEvent?.src) {
            setResponseEvent(true)
        } else {
            setResponseEvent(false)
        }
    }, [allEvents, params, allTransactions, allClusterlets, src, dst])

    const checkMessageValidationAlert = () => {
        const key = 'disabledMessageDuplicationAlerts';

        const stored = localStorage.getItem(key);
        if (stored === undefined || stored === null) return true;

        let alertsArray = [];
        try {
            alertsArray = stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error("Failed to parse disabledMessageDuplicationAlerts from localStorage", e);
        }

        const exists = alertsArray.some(
            (item) => item.blueprint === blueprintID && item.protocol === protocol
        );

        return exists ? false : true;
    }

    const showMessageDuplicationAlert = checkMessageValidationAlert();
    const duplicatedMessageList = filterSchemaMessages(allMessages, messagesFromSchema, storeMessages)

    const handleCreateMessage = (inputValue) => {
        if (!/^[a-zA-Z0-9_{}/]*$/.test(inputValue)) {
            setError("selectedMessage", { message: "Invalid message" });
            return;
        }

        clearErrors("selectedMessage");

        const newOption = { label: inputValue, value: generateMongoId(), type: "user" };
        setMessageList(prev => {
            const updated = [...prev, newOption];
            return updated.sort((a, b) => {
                if (a.type !== b.type) {
                  return a.type === "user" ? -1 : 1;
                }
            
                return a.label.localeCompare(b.label, undefined, {
                  sensitivity: "base" 
                });
            });
          });
          
        setSelectedMessage(newOption);

        const messageData = {
            _id: newOption.value,
            name: inputValue,
            type: constructIds.find((item) => item.type === "message").id,
        };

        dispatch(invokePostService("createMessage", { messageData }, []))
            .then((savedData) => {
                if (!savedData.status) {
                    setMessageList((prev) => {
                        const updated = prev.filter((item) => item.value !== newOption.value);
                        return updated.sort((a, b) => {
                            if (a.type === b.type) return 0;
                            return a.type === "user" ? -1 : 1;
                          });
                    });
                    if (savedData.errors && savedData.errors[0] && savedData.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        setError("selectedMessage", { message: savedData.errors[0].message });
                    }else {
                        dispatch(
                            handleSnackBar({
                                open: true,
                                message: "Message creation failed",
                                severity: "error",
                            })
                        );
                    }
                }
            });
    };


    return (
        <>
            {loading &&
                <SkeletonLoader
                    type="form"
                    rows={5}
                    grid={[1, 1, 1, 1, 2]}
                />
            }

            {!loading  && 
                <>
                    <Grid id={"edit_event_form"} container direction={"row"} spacing={3}>

                        {/* Name */}
                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <Grid item style={{ flex: 2 }}>
                                <TextField
                                    type={"text"}
                                    name={"name"}
                                    autoFocus
                                    fullWidth
                                    required
                                    label={"Event Name"}
                                    defaultValue={selectedEvent.name}
                                    variant="outlined"
                                    inputRef={register({ ...basic, validate: duplicateEventName({ allEvents: events, allTransactionsList, selectedTransaction, clusterlets, selectedSrc: source, element }) })}
                                    error={errors?.name ? true : false}
                                    helperText={errors?.name ? errors.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                                />
                            </Grid>
                            {
                                isResponseEvent &&
                                <Grid item>
                                    <Controller
                                        name="error_resp_event"
                                        control={control}
                                        render={(data) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        {...data.field}
                                                        onChange={e => {
                                                            data.onChange(e.target.checked)
                                                        }}
                                                        name="error_resp_event"
                                                        id="error_resp_event"
                                                        color="primary"
                                                        value={data?.value}
                                                        checked={data?.value}
                                                    />
                                                }
                                                label="Mark as error response"
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                        </Grid>


                        <Grid item xs={12}>
                            <Autocomplete
                                value={selectedMessage || null}
                                onChange={(event, newValue) => {
                                    if (typeof newValue === "string") {
                                        // User directly typed and hit enter
                                        const duplicateMessage = messageList.find(item => item.label === newValue);
                                        if (duplicateMessage) {
                                            setSelectedMessage(duplicateMessage);
                                        } else {
                                            handleCreateMessage(newValue);
                                        }
                                    } else if (newValue && newValue.inputValue) {
                                        // User selected "Create new message ..."
                                        handleCreateMessage(newValue.inputValue);
                                    } else {
                                        // User selected from list
                                        setSelectedMessage(newValue);
                                    }
                                }}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);
                                    if (
                                        params.inputValue !== "" &&
                                        !filtered.some((option) => option.label === params.inputValue)
                                    ) {
                                        filtered.unshift({
                                            inputValue: params.inputValue,
                                            label: `Create new event type '${params.inputValue}'`,
                                        });
                                    }
                                    console.log({filtered})
                                    return filtered;
                                }}
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                                id="selectedMessage"
                                options={messageList}
                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    if (option.inputValue) return option.inputValue;
                                    return option.label;
                                }}
                                groupBy={(option) => {
                                    if (option.inputValue) return ""; 
                                    return option.type === "user" ? "Your Event Types" : "Built-in Event Types";
                                }} 
                                renderGroup={(params) => (
                                    <li key={params.key}>
                                      <div
                                        style={{
                                          top: 0,
                                          zIndex: 1,
                                          background: "#fff",
                                          padding: "8px 10px",
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          color: "#404040",
                                          borderBottom: "1px solid #dcdcdc", 
                                          display: `${params.group ? "block" :  "none"}` ,
                                        }}
                                      >
                                        {params.group}
                                      </div>
                                      <ul style={{ padding: 0 }}>{params.children}</ul>
                                    </li>
                                )}
                                  
                                renderOption={(option) => (
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                      <span style={{ fontWeight: 500 }}>{option.label}</span>
                                
                                      {option.desc && option.desc !== "" && (
                                        <span
                                          style={{
                                            fontSize: "0.75rem",
                                            color: "#757575",
                                            marginTop: 2
                                          }}
                                        >
                                          {option.desc}
                                        </span>
                                      )}
                                    </div>
                                  )}
                                freeSolo
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Event Type"
                                        variant="outlined"
                                        fullWidth
                                        required
                                        name={"selectedMessage"}
                                        placeholder={messageList.length === 0 ? "No event type found. Type to create one" : "Create event type"}
                                        error={Boolean(errors?.selectedMessage)}
                                        helperText={errors?.selectedMessage?.message || ""}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={register({ required: "Event type is required" })}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                type={"text"}
                                name={"desc"}
                                fullWidth
                                multiline={true}
                                rows={2}
                                label={"Description"}
                                variant="outlined"
                                inputRef={register({ required: false, validate: validateNonAsciiChars })}
                                error={errors?.desc}
                                helperText={errors?.desc ? errors?.desc?.message : ''}
                            />

                        </Grid>


                        <Grid item xs={showTargetInstance ? 4 : 6}>
                            {/* <TextField
                            type={"text"}
                            name={"src"}
                            fullWidth
                            label={"Source"}
                            variant="outlined"
                            // disabled={true}
                            inputRef={register({ ...basic })}
                            helperText={srcNodeLabel}
                        /> */}
                            <Controller
                                name="src"
                                control={control}
                                // defaultValue={src}
                                rules={{ ...requiredOnly, required: true }}
                                render={({ field, value, onChange }) =>
                                    <TextField
                                        name="src"
                                        {...field}
                                        label={"Source"}
                                        fullWidth
                                        required
                                        value={value}
                                        select
                                        variant="outlined"
                                        onChange={e => { onChange(e); listenChange(e) }}
                                        error={errors?.src ? true : false}
                                        helperText={messages[errors?.src?.type] ? 'Select a source' : srcError ? <div style={{ color: "red" }}>{srcError}</div> : ""}
                                    >
                                        <MenuItem key={1} value={""}>Select</MenuItem>
                                        {transactionNodes.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                }
                            />
                        </Grid>

                        <Grid item xs={showTargetInstance ? 4 : 6}>
                            <Controller
                                name="dst"
                                control={control}
                                // defaultValue={dst}
                                rules={{ ...requiredOnly, required: true }}
                                render={({ field, value, onChange }) =>
                                    <TextField
                                        name="dst"
                                        {...field}
                                        label={"Destination"}
                                        fullWidth
                                        required
                                        value={value}
                                        select
                                        variant="outlined"
                                        onChange={e => { onChange(e); listenChange(e); }}
                                        error={errors?.dst ? true : false}
                                        helperText={messages[errors?.dst?.type] ? 'Select a destination' : dstError ? <div style={{ color: "red" }}>{dstError}</div> : ""}
                                    >
                                        <MenuItem key={1} value={""}>Select</MenuItem>
                                        {transactionNodes.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                }
                            />
                        </Grid>

                        {/* Target Instance */}
                        {showTargetInstance &&
                            <Grid item xs={4}>
                                <TextField
                                    name="instance"
                                    // defaultValue={selectedEvent?.instance}
                                    InputLabelProps={{ shrink: true }}
                                    type={"text"}
                                    fullWidth
                                    label={"Target Instance"}
                                    variant="outlined"
                                    inputRef={register({ ...patternOnly })}
                                    error={errors?.instance ? true : false}
                                    helperText={errors?.instance ? messages[errors?.instance?.type] : ''}
                                />
                            </Grid>}


                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                            <UpdateCancel onUpdate={handleSubmit(onUpdate)} content={isCreating ? 'Updating..' : 'Update'} onCancel={onCancel} updateDisable={action.action === 'create_message' || dataLoading || isCreating ? true : false} typesNotIn={['transaction', 'view']} />
                        </Grid>

                    </Grid>

                    {alertDialog === true && <UpdateEventAlert onCompletion={handleSubmit(onEventUpdate)} eventId={element.id} showAlert={setAlertDialog} typesNotIn={['transaction', 'view']} />}

                    {/* {filterSchemaMessages(allMessages, messagesFromSchema, storeMessages ) && <DatabaseSchemaValidationAlert/>} */}
                    {/* { findDuplicatedMessages && <DatabaseSchemaValidationAlert element messagesList={filterSchemaMessages(allMessages, messagesFromSchema, storeMessages)} />} */}
                    {showMessageDuplicationAlert && duplicatedMessageList?.length > 0 && <DatabaseSchemaValidationAlert messagesList={duplicatedMessageList} blueprint={blueprintID} protocol={protocol} />}


                </>}

        </>
    )

}